import { render, staticRenderFns } from "./zyfPrice.vue?vue&type=template&id=04b3a8ff&scoped=true"
import script from "./zyfPrice.vue?vue&type=script&lang=js"
export * from "./zyfPrice.vue?vue&type=script&lang=js"
import style0 from "./zyfPrice.vue?vue&type=style&index=0&id=04b3a8ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3a8ff",
  null
  
)

export default component.exports